module.exports = __webpack_public_path__ + "img/intecon.13beec9a.svg";